<template>
    <div>
        <div class="trending-topics-widget">
          <div class="topic-card-widget top-topics">
                <div class="header-topic-widget">
                    <p>Top 10 Topics</p>
                </div>
                <div class="topic-chart-content" ref="topicListContent">
                  <NoResultsFound v-if="!Array.isArray(trendingTopicsStat) || trendingTopicsStat.length <= 0" class="no-result-content"/>
                  <div v-else v-for="(topic,index) in trendingTopicsStat" :key="topic.name">
                    <div class="topic-item">
                      <div class="topic-index">
                        <p>{{index+1}}</p>
                      </div>
                      <div class="topic-content">
                        <div class="topic-header">
                          <p>{{ topic.name}}</p>
                          <p>{{ topic.count }}</p>
                        </div>
                        <div class="topic-progress-bar">
                          <div class="progress striped" v-if="trendingTopicsStat[0].count > 0" v-bind:style="{ width: (topic.count / trendingTopicsStat[0].count) * 100 + '%' }"></div>
                        </div>
                        <div v-if="topicNameToTagListNameMap[topic.id] !== undefined && topicNameToTagListNameMap[topic.id].displayedTagList.length > 0" class="topic-tag-content" ref="topicTagsContent">
                          <div v-for="(displayedTag, index) in topicNameToTagListNameMap[topic.id].displayedTagList" :key="`display-`+index" class="tag-list"  >
                            <div class="tag-item" ref="tagItemElem">
                              <p>{{displayedTag}}</p>
                            </div>
                          </div>
                          <div v-if="topicNameToTagListNameMap[topic.id].hiddenTagList.length > 0" class="tag-list" >
                            <p @mouseover="onHoverHiddenTag(topic.id)" @mouseleave="onHoverHiddenTag"> +{{ topicNameToTagListNameMap[topic.id].hiddenTagList.length }}</p>
                            <div v-if="hoveredHiddenTag === topic.id" class="hidden-tag-popover">
                              <div v-for="hiddenTag in topicNameToTagListNameMap[topic.id].hiddenTagList" :key="`hidden-`+hiddenTag">
                                <p>{{hiddenTag}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="topic-card-widget timeline-top-topics">
                <div class="header-topic-widget">
                    <p>Timeline of Top 10 Topics</p>
                </div>
                <NoResultsFound v-if="!Array.isArray(trendingTopicsStat) || trendingTopicsStat.length <= 0" class="no-result-content"/>
                <div v-else class="topic-chart-content">
                    <GChart class="g-chart" type="LineChart" :data="historyData"  :options="lineChartOptions"></GChart>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GChart } from 'vue-google-charts';
import { mapGetters, mapActions } from 'vuex';
import { DateTime } from 'luxon';
import NoResultsFound from '../NoResultsFound.vue';

export default {
  name: 'trending-topics-widget',
  components: {
    GChart,
    NoResultsFound
  },
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      lineChartOptions: {
        legend: { position: 'bottom' },
        chartArea: {
          top: 50,
          width: '90%',
          height: '65%',
        },
        hAxis: { showTextEvery: 4 },
        colors: ['#646A8C', '#FEA955', '#FCD14E', '#DADCE4', '#A0D467', '#EF6767', '#59CBE8', '#3371FF', '#AC92ED', '#EC87BF'],
      },
      historyData: [],
      trendingTopicsStat: [],
      topicContainerElemWidth: 0,
      topicNameToTagListNameMap: {},
      hoveredHiddenTag: '',
    };
  },
  computed: {
    ...mapGetters({
      trendingTopicsData: 'dashboard/trendingTopicsData'
    }),

  },
  methods: {
    ...mapActions({
      loadTrendingTopicsData: 'dashboard/loadTrendingTopicsData',
    }),
    trendingTopicsHistoryData() {
      this.trendingTopicsStat = this.trendingTopicsData.topTopicUsageStat;
      const listOfHeader = this.trendingTopicsStat.map((item) => item.name);

      const headerRow = ['Date', ...listOfHeader];
      if (Array.isArray(this.trendingTopicsStat) && this.trendingTopicsStat.length > 0) {
        const transformedData = this.trendingTopicsData.topTopicUsageHistory.map((item) => {
          const topicNameToTopicCountOfEachDateBucketMap = item.topics.reduce((map, topic) => {
            // eslint-disable-next-line no-param-reassign
            map[topic.name] = (map[topic.name] || 0) + topic.count;
            return map;
          }, {});

          const eachDateBucketChartData = [];
          for (const header of listOfHeader) {
            eachDateBucketChartData.push(topicNameToTopicCountOfEachDateBucketMap[header] || 0);
          }

          // const topicCounts = item.topics.map((topic) => topic.count);
          return [DateTime.fromMillis(item.date).setZone('Asia/Bangkok').toFormat('dd LLL'), ...eachDateBucketChartData];
        });
        this.historyData = [headerRow, ...transformedData];
        if (transformedData.length <= 10) {
          this.lineChartOptions.hAxis.showTextEvery = 1;
        } else if (transformedData.length > 10 && transformedData.length <= 20) {
          this.lineChartOptions.hAxis.showTextEvery = 2;
        } else {
          this.lineChartOptions.hAxis.showTextEvery = 4;
        }
      } else {
        this.historyData = [['Date', 'No Data'], ['No Data', 0]];
      }
      this.$nextTick(() => {
        this.mapTagsToDisplayAndHiddenByWidth();
      });
    },
    mapTagsToDisplayAndHiddenByWidth() {
      const result = {};

      // Calculate the width of the topic container by accounting for padding and other elements:
      // - 84px: Total gap between the widget width and the actual container width
      // - 39px: Width of the badge element that displays the count of hidden tags
      this.topicContainerElemWidth = this.$refs.topicListContent.offsetWidth - 84 - 39;
      /* eslint-disable-next-line no-plusplus */
      for (let i = 0; i < this.trendingTopicsStat.length; i++) {
        const topic = this.trendingTopicsStat[i];
        if (!topic || !Array.isArray(topic.tags)) {
          /* eslint-disable-next-line no-continue */
          continue;
        }
        let totalTagItemWidth = 0;
        const displayedTagList = [];
        const hiddenTagList = [];
        /* eslint-disable-next-line no-plusplus */
        for (let j = 0; j < topic.tags.length; j++) {
          totalTagItemWidth += this.calculateTagItemWidth(topic.tags[j]);
          if (totalTagItemWidth <= this.topicContainerElemWidth) {
            // Add to displayed list if fits within container
            displayedTagList.push(topic.tags[j]);
          } else {
            // Otherwise, add to hidden list
            hiddenTagList.push(topic.tags[j]);
          }
        }

        result[topic.id] = {
          displayedTagList,
          hiddenTagList,
        };
      }
      this.topicNameToTagListNameMap = JSON.parse(JSON.stringify(result));
    },
    calculateTagItemWidth(text) {
      // textWidth + padding + border + margin right
      // - 3px: Add for the slight difference in the actual text width
      return this.getTextWidthWithNewStyle(text) + (6 * 2) + 2 + 4 + 3;
    },
    getTextWidthWithNewStyle(text) {
      // Create a temporary canvas element
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = '400 12px "Public Sans"'; // Font-weight, font-size, and font-family

      // Measure the width of the text
      const metrics = context.measureText(text);
      return metrics.width;
    },
    onHoverHiddenTag(topicId) {
      this.hoveredHiddenTag = topicId;
    },

    async initData() {
      await this.loadTrendingTopicsData({
        criteria: this.criteria,
      });
      this.trendingTopicsHistoryData();
    }
  },
  watch: {
    criteria: {
      handler: 'initData',
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.trending-topics-widget{
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 24px;
    .topic-card-widget{
        background-color: #FFFFFF;
        border-radius: 16px;
        max-height: 590px;
        .header-topic-widget{
            padding: 16px 16px 12px 16px;
            border-bottom: 1px solid #E9EBEC;
            font-size: 16px;
            font-weight: 500;
            line-height: 19.2px;
            color: #111B49;
            display: flex;
            justify-content: space-between;
            p {
                margin-bottom: 0px
            }
        }
    }
    .topic-card-widget.top-topics{
        grid-column: span 3 / span 3;
        .topic-chart-content{
          padding: 20px;
            max-height: 530px;
            overflow-x: auto;
        }
    }
    .topic-card-widget.timeline-top-topics{
        grid-column: span 4 / span 4;
        .topic-chart-content{
        padding: 20px;
        height: 90%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .g-chart{
          height: 100%;
          width: 100%;
        }
        }
    }
    .topic-chart-content{
      .topic-item{
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        color: #4B5178;
        padding-bottom: 6px;
        p {
          margin-bottom: 0px;
        }
        .topic-index{
          width: 21px;
          text-align: center;
        }
        .topic-content{
        padding: 6px 20px 6px 16px;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        .topic-header{
          display: flex;
          flex-grow: 1;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }
        }
        .topic-progress-bar {
          width: 100%;
          background-color: #e0e0e0;
          border-radius: 8px;
          overflow: hidden;
          height: 6px;
          margin-bottom: 8px;
        }
        .progress {
          height: 100%;
          background-color: #3371FF;
          width: 0;
          // transition: width 0.3s ease;
          border-radius: 8px;
        }
        .progress.striped::before {
          content: '';/* Pseudo-element for stripes */
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.1) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.1) 50%,
            rgba(255, 255, 255, 0.1) 75%,
            transparent 75%,
            transparent 100%
          );
          background-size: 8px 8px;/* Size of the stripe pattern */
        }
        .topic-tag-content{
          display: flex;
          .tag-list{
            border: 1px solid #E7E8EE;
            border-radius: 64px;
            padding: 3px 6px ;
            margin-right: 4px;
            margin-bottom: 4px;
            position: relative;
            .hidden-tag-popover {
              z-index: 99;
              position: absolute;
              top: -20px;
              left: 32px;
              background-color: #111b49;
              border: 1px solid #111b49;
              border-radius: 8px;
              padding: 12px;
              p {
                color: #FFFFFF;
                line-height: 21px;
              }
            }
          }
          p {
            font-size: 12px;
            font-weight: 400;
            line-height: 10.5px;
          }
        }
      }
    }
    .no-result-content{
      margin-top: 97px;
      margin-bottom: 97px;
    }
}
</style>
